import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SideMenuService {
    constructor(){}

    private sideMenuCollapsedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

    SideMenuCollapsed: Observable<boolean> = this.sideMenuCollapsedSubject.asObservable();

    SetSideMenuCollapse(){
        this.sideMenuCollapsedSubject.next(!this.sideMenuCollapsedSubject.value);
    }

    SetSideMenuCollapseWithValue(value: boolean){
        this.sideMenuCollapsedSubject.next(value);
    }
}